module.exports = __webpack_public_path__ + "img/stickers-liquidation-communaute.ea132352.jpg";